import { GripVertical } from 'lucide-react';
import { PanelResizeHandle } from 'react-resizable-panels';
import './resizeHandle.styles.css';

type ResizeHandleProps = {
    id?: string | null | undefined;
};

function ResizeHandle({ id }: ResizeHandleProps) {
    return (
        <PanelResizeHandle className="resize-handle__outer" id={id}>
            <div className="resize-handle__inner">
                <GripVertical className="resize-handle__icon" />
            </div>
        </PanelResizeHandle>
    );
}

export default ResizeHandle;
